/**
 * Convert raw message content into a human-readable preview.
 * Handles structured report JSON (including truncated) and legacy text format.
 */
export function formatMessagePreview(content: string): string {
  // New JSON format (full or truncated)
  if (content.startsWith('{"__type":"report"')) {
    try {
      const parsed = JSON.parse(content);
      if (parsed?.__type === "report") {
        const type = parsed.problemType || parsed.type || "Report";
        const desc = parsed.description || "";
        const preview = desc.length > 50 ? desc.slice(0, 50) + "..." : desc;
        return preview ? `\u{1F4CB} ${type}: ${preview}` : `\u{1F4CB} ${type}`;
      }
    } catch {
      const descMatch = content.match(/"description"\s*:\s*"([^"]*)"/);
      if (descMatch) {
        const desc = descMatch[1].length > 50 ? descMatch[1].slice(0, 50) + "..." : descMatch[1];
        return `\u{1F4CB} Report: ${desc}`;
      }
      return "\u{1F4CB} Report";
    }
  }

  // Legacy text format: "--- Report title ---" (multiline or single-line truncated)
  if (content.startsWith("---")) {
    // Try to extract the problem type from the second line (e.g. "Тип проблемы: Некорректный контент")
    const lines = content.split("\n").filter((l) => l.trim());
    if (lines.length > 1) {
      const typeLine = lines[1];
      const typeValue = typeLine.includes(":") ? typeLine.split(":").slice(1).join(":").trim() : "";
      if (typeValue) {
        return `\u{1F4CB} ${typeValue}`;
      }
    }
    return "\u{1F4CB} Report";
  }

  return content;
}
